/**
 * Fix-first ordering for a row's typed resources (``row.errors[].links`` from
 * phase 1). The drawer's ``FixResourceLinks`` renders the ordered links as a
 * compact teal link row; this module owns only the ordering so the priority
 * (actionable guide first, supporting references and the human contact trail
 * behind it) lives in one place.
 */
import type { ReferenceLink } from '../../../shared/referenceLinks/types'
import { type ReferenceLinkType } from '../../../shared/referenceLinks/linkStyles'

// Fix-first ordering: the actionable guide leads, supporting references and
// the human contact trail behind it. Unknown types sort last (stable).
const TYPE_ORDER: ReferenceLinkType[] = [
  'fix_guide',
  'video',
  'overview',
  'contact',
]

const orderOf = (linkType: string): number => {
  const idx = TYPE_ORDER.indexOf(linkType as ReferenceLinkType)
  return idx === -1 ? TYPE_ORDER.length : idx
}

// Stable sort by type priority - keep original order within a type.
export const orderReferenceLinks = (
  links: ReferenceLink[] | null | undefined,
): ReferenceLink[] => {
  if (!links || links.length === 0) return []
  return links
    .map((link, idx) => ({ link, idx }))
    .sort(
      (a, b) =>
        orderOf(a.link.link_type) - orderOf(b.link.link_type) || a.idx - b.idx,
    )
    .map(({ link }) => link)
}
